import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { useT, i18n } from '../services/i18n';

const BestPriceBadge = ({ product, size = 'sm' }) => {
  const { t } = useT();
  const b = product?.best_price;
  if (!b?.active) return null;
  const date = b.checked_at ? new Date(b.checked_at).toLocaleDateString(i18n.locale()) : '';
  const title = t('common.bestPriceTitle', { n: b.competitors, date: date ? t('common.onDate', { date }) : '' });
  const cls = size === 'lg' ? 'text-sm px-3 py-1.5 gap-1.5' : 'text-[11px] px-2 py-0.5 gap-1';
  return (
    <span data-testid={`best-price-badge-${product.id}`} title={title} className={`inline-flex items-center font-semibold rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 whitespace-nowrap ${cls}`}>
      <BadgeCheck size={size === 'lg' ? 16 : 12} /> {t('common.bestPrice')}
    </span>
  );
};

export default BestPriceBadge;
